export default __webpack_public_path__ + "static/media/mmoulika.ccb2450d.png";